import { Modal } from "react-bootstrap";
import { Form } from "react-bootstrap";
import "./ClaimOnBehalfModal.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX } from "@fortawesome/free-solid-svg-icons";
import { useMemo, useState } from "react";
import LoadingSpinner from "../Loader/Loader";
import { useFetchByPostAction } from "../../hooks/useFetch";
import { getObjectCreator } from "../../utils/localStorage/localStorage";
import endPoint from "../../constants/endPoint";
import { useAuth } from "../AuthProvider/useAuth";
import { useNavigate } from "react-router";
import appConfig from "../../constants/config";
import { translate } from "../../utils/translateUtils";

export type ClaimOnBehalfUser = {
  id: string;
  text: string;
};

const ClaimOnBehalfModal = ({
  onClose,
  visible,
}: {
  onClose: any;
  visible: boolean;
}) => {
  const [filter, setFilter] = useState<string>("");
  const { impersonateUser, isImpersonating } = useAuth();
  const navigate = useNavigate();

  const params = useMemo(
    () => ({
      employee_id: localStorage.getItem("employee_id"),
      country_code: localStorage.getItem("country_code"),
      user_roles: getObjectCreator()?.user_roles,
    }),
    [visible]
  );

  const { data, isLoading } = useFetchByPostAction<ClaimOnBehalfUser[]>(
    endPoint.GetOnBehalf,
    params
  );

  const ClaimOnBehalfItem = ({ id, name }: { name: string; id: string }) => {
    const onImpersonateUser = async (id: string) => {
      await impersonateUser(id);

      const windowLocation = window.location.href;
      const virtualPathIndex = windowLocation.indexOf(window.location.pathname);

      switch (true) {
        case windowLocation.includes("ClaimItems"):
          navigate(`/ClaimItems/ClaimItems`);
          break;
        case windowLocation.includes("ExpReport"):
          navigate(windowLocation.slice(virtualPathIndex).split("&")[0].replace(appConfig.connectionString.appBaseName, ""));
          break;
        case windowLocation === "":
          navigate("/not-found");
          break;
        default:
          navigate(windowLocation.slice(virtualPathIndex).replace(appConfig.connectionString.appBaseName, ""));
          break;
      }

    };
    return (
      <div
        className="claimOnBehalfList d-flex flex-column gap-1"
        onClick={() => onImpersonateUser(id)}
      >
        <div className="claimOnBehalfListItem d-flex gap-3 align-items-center">
          <div className="icon rounded-circle bg-red-400 px-3 py-2 text-white fw-bold">
            {name.substring(0, 1).toLocaleUpperCase()}
          </div>
          <div className="user-name fw-bold text-text-gray-700">{name}</div>
        </div>
      </div>
    );
  };

  return (
    <>
      <LoadingSpinner loading={isLoading || isImpersonating} />
      <Modal show={visible} centered={true} onHide={onClose!}>
        <Modal.Body className="p-4">
          <div className="d-flex justify-content-between pb-3">
            <h3 className="text-gray-800">{translate("Choose a User")}</h3>
            <button className="btn btn-light" onClick={onClose!}>
              <FontAwesomeIcon icon={faX} />
            </button>
          </div>
          <Form.Control
            placeholder={translate("Name, ID")}
            onChange={(e) => setFilter(e.target.value)}
          />
          <p className="text-gray-600 p-2 mb-0">
            {translate("Choose a user you want to Claim on Behalf")}
          </p>
          <div className="overflow-y-scroll d-flex flex-column gap-2 claimOnBehalfListContainer">
            {data &&
              data.length > 0 &&
              data
                .filter(
                  (item) =>
                    ((filter &&
                      item.text.toLowerCase().indexOf(filter.toLowerCase()) >
                      -1) ||
                      item.id.indexOf(filter) > -1 ||
                      !filter) &&
                    item.id !== getObjectCreator().personnel_number
                )
                .map((item, index) => (
                  <ClaimOnBehalfItem
                    key={index}
                    name={item.text.trim()}
                    id={item.id}
                  />
                ))}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ClaimOnBehalfModal;
